/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlanDiscount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlanDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/PaymentPlanDiscount"
  
}) {
let constantData = 'Payment plan discount'
let paymentPlanDiscounts0ValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'discounts.[0]',
format: fromHelpers.getConfiguredDiscount,
})
let aggregateData = fromAggregate.join(constantData, paymentPlanDiscounts0ValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let paymentPlanPaymentPlanDiscountValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'payment_plan_discount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="PaymentPlanDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Payment plan discount'"
 data="payment_plan.discounts.[0]"
 format="helpers.js getConfiguredDiscount"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.payment_plan_discount"
 format="/Data/format.js numberMoney"
 text={paymentPlanPaymentPlanDiscountValueData}
/>
</div>
{children}
</React.Fragment>)
}